/** API ActivityLog ↔ UI activity log fields. */

export function activityLogFromApi(row) {
  if (!row) return null;
  const action = row.action ?? row.actionType ?? '';
  const at = row.createdAt ?? row.at ?? null;
  const staffDbId =
    row.staff?.id ?? (typeof row.staffId === 'number' ? row.staffId : null);
  return {
    id: row.id,
    logId: row.logId ?? (row.id != null ? String(row.id) : ''),
    staffId: row.staff?.code ?? (typeof row.staffId === 'string' ? row.staffId : null),
    staffDbId,
    staffName: row.staff?.fullName ?? row.staffName ?? '',
    actorType: row.actorType ?? 'staff',
    action,
    actionType: action,
    module: row.module ?? '',
    summary: row.summary ?? '',
    entityType: row.entityType ?? null,
    entityId: row.entityId != null ? String(row.entityId) : null,
    ip: row.ip ?? null,
    meta: row.meta ?? null,
    createdAt: at,
    at,
  };
}
